// import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
// import Checkout from "../services/Stripe/checkout";
import Subscription from "../services/Stripe/subscription";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

// declare webkit & chrome for platform detection
declare global {
  interface Window {
    webkit?: {
      messageHandlers?: any;
    };
  }
}

const isMacOSApp = window.webkit?.messageHandlers?.callbackHandler;

const openBillingWithSafari = async () => {
  const current_url = window.location.href;
  window.webkit.messageHandlers.callbackHandler.postMessage({ 
      action: "redirectLocation", 
      url: current_url 
  });
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const StripeScreen = () => {
  // I18N
  const { t } = useTranslation();
  // PARAMS
  const { type } = useParams<{ type: string }>();
  // NAVIGATION
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = t('title.billing');
    if (isMacOSApp) {
      (async () => {
        await openBillingWithSafari();
        navigate(t('link.dashboard'), { state: { status: "bg-success", title: "", toastMessage: t('profile.change_plan'), toastUsername: false }});
      })();
    }
  }, []);
  
  return (
    <Elements stripe={stripePromise}>
      {/* <Checkout /> */}
      <Subscription type={type}/>
    </Elements>
  );
}

export default StripeScreen;